import profileImageUrl from "@/assets/profile.svg"
import reminderBellImageUrl from "@/assets/reminder-bell.svg"
import tablets2ImageUrl from "@/assets/tablets2.svg"
import videoImageUrl from "@/assets/video.svg"
import BackButton from "@/components/BackButton"
import { Button } from "@/components/chadcn/Button"
import Page from "@/components/Page"
import { useLogOutMutation } from "@/data/queries"
import { ROUTES } from "@/routes"
import { ChevronRightIcon } from "@radix-ui/react-icons"
import { Link, useNavigate } from "react-router"

type SettingsLinkProps = {
  to: string
  icon: string
  label: string
}

const SettingsLink = ({ to, icon, label }: SettingsLinkProps) => (
  <Link
    to={to}
    className="flex items-center gap-4 rounded-md border-4 border-primary bg-white px-4 py-4 shadow-card hover:bg-secondary"
  >
    <img src={icon} alt="" className="h-[50px] w-[50px]" />
    <span className="flex-1 text-h4">{label}</span>
    <ChevronRightIcon aria-hidden className="h-5 w-5 text-primary-contrast" />
  </Link>
)

const SettingsPage = () => {
  const navigate = useNavigate()
  const { mutate: logOut, isPending } = useLogOutMutation()

  const handleLogOut = () => {
    logOut(undefined, {
      onSuccess: () => navigate(ROUTES.SIGN_IN, { replace: true }),
    })
  }

  return (
    <Page showAppbar={false}>
      <div className="flex min-h-[calc(100vh-56px)] flex-col gap-6">
        <BackButton />
        <h1 className="text-h2">Settings and extra info</h1>

        <nav aria-label="Settings navigation" className="flex flex-col gap-3">
          <SettingsLink to={ROUTES.UPDATE_PROFILE} icon={profileImageUrl} label="Profile" />
          <SettingsLink
            to={ROUTES.UPDATE_MEDICATIONS}
            icon={tablets2ImageUrl}
            label="Medications"
          />
          <SettingsLink
            to={ROUTES.UPDATE_REMINDERS}
            icon={reminderBellImageUrl}
            label="Reminders"
          />
          <SettingsLink
            to={ROUTES.INSTRUCTION_VIDEOS}
            icon={videoImageUrl}
            label="Instruction videos"
          />
        </nav>

        <div className="mt-auto flex flex-col gap-3 pb-4">
          <a
            href="https://www.bloom-life.com/blood-glucose-contact"
            target="_blank"
            rel="noreferrer"
          >
            <Button type="button" className="w-full py-2 text-base">
              Contact Bloomlife
            </Button>
          </a>
          <Button
            type="button"
            variant="outline"
            disabled={isPending}
            className="w-full py-2 text-base"
            onClick={handleLogOut}
          >
            Log out
          </Button>
        </div>
      </div>
    </Page>
  )
}

export default SettingsPage
